import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import {List, ListItem} from 'material-ui/List'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';

import CommentForm from 'components/Comments/CommentForm'
import CommentList from 'components/Comments/CommentList'

import { objectComments } from 'selectors/comments'
import { properties } from 'selectors/entities'
import { currentUserNotifications, currentUserOpenNotifications } from 'selectors/notifications'

import EventList from '../events/List'
import commentWizard from 'actions/commentWizard'
import tableActions from 'actions/table'
import commentActions from 'actions/commentActions'


let select = (state, props) => ({
	mode: state.commentBuffer.mode
  , comments: objectComments(state, props)
  , currentUserOpenNotifications: currentUserOpenNotifications(state)
	, properties: properties(state)
})

export class Comments extends Component {
	state = {
    value1: this.props.propertyID || '0'
	, value2: null
  };
	handleChange = (event, index, value1) => this.setState({value1});
	handleChange2 = (event, index, value2) => this.setState({value2});
	render(){
		let { props } = this
		// console.log(props.propertyID);
		// console.log(this.state.value1);
		// debugger
		//if (props.propertyID && this.state.value1!==props.propertyID) this.setState({value1: props.propertyID});
		return(
			<div
				style={{position:"absolute", display:"flex", width:"100vw", height:"100vh", backgroundColor: "rgba(0,0,0,0.3)", zIndex:"999"}}
			>
				<div
					style={{width:"35%", paddingTop:"10px", padding:"30px", margin:"auto", vertical: "middle", backgroundColor: "white"}}

				>
					 <div
						 style={{float:"right", cursor:"pointer"}}
						 onClick={()=>{props.COMMENTWIZARD_HIDE();}}
					 >
					 <svg
						width="18px"
						height="25px"
						viewBox="0 0 24 24"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							verticalAlign: "middle"
							, marginRight: "4px"
							, marginTop: "-2px"
						}}
					>
						<g transform="rotate(-48.030906677246094 12.000000000000004 ,12) " stroke="red" fill="none" id="Page-1">
							<g id="Page-1" stroke={"#5ae4c3"} strokeWidth="2" fill="none" fillRule="evenodd">
								<g id="Group-2" transform="translate(1.000000, 1.000000)" stroke={"#5ae4c3"} strokeWidth="2">
									<path d="M11,4.5 L11,17.5" id="Line" strokeLinecap="square"></path>
									<path d="M5,11 L17,11" id="Line" strokeLinecap="square"></path>
									<circle id="Oval-1" cx="11" cy="11" r="11"></circle>
								</g>
							</g>
						</g>
					</svg>
					</div>
					<div>
						<SelectField
							value={this.state.value1}
	          	onChange={this.handleChange}
		        >
							<MenuItem value={'0'} primaryText={'General discussion '} />
							{R.map((property, index)=>(
								<MenuItem value={property._id} primaryText={property.alias} />
							), R.values(props.properties))}
		        </SelectField>
					</div>

					<div>
						<SelectField
							hintText="Select secondary context"
							value={this.state.value2}
							onChange={this.handleChange2}
							style={{position: "relative", width: "100%", top: "-20px"}}
							disabled={this.state.value1==="0"}
						>
							<EventList propertyID={this.state.value1} tabSelected={"Timeline"} />
						</SelectField>
					</div>
					{props.propertyID!==this.state.value1?
						<Link
								to={this.state.value1==='0'?`/landlord/home/?comments=true`:`/landlord/property/${this.state.value1}?comments=true`}
								style={{
									textDecoration: 'underline'
									, color: 'inherit'
									, cursor: "pointer"
								}}
								onClick={()=>{
									props.COMMENTWIZARD_HIDE();
									props.COMMENT_ADD();
									props.CHOOSE_ITEM(false);
								}}
							>
							<FlatButton
								label={"Next"}
								primary={true}
								style={{float: 'right'}}
							/>
						</Link>
						:
						<div
								style={{
									textDecoration: 'underline'
									, color: 'inherit'
									, cursor: "pointer"
								}}
								onClick={()=>{
										props.COMMENTWIZARD_HIDE();
										props.COMMENT_ADD();
								}}
							>
							<FlatButton
								label={"Next"}
								primary={true}
								style={{float: 'right'}}
							/>
						</div>
					}
					{/*{ (props.mode == 'new') && <CommentForm objectID={this.props.objectID} general={true} path={props.path} />}
					<CommentList objectID={this.props.objectID} path={props.path}/>
					<List>
						  {props.currentUserOpenNotifications.length ?
							  R.values(
								R.mapObjIndexed((notification, index) =>
									<NotificationCard notificationID={notification._id} />
								, props.currentUserOpenNotifications
								)
							  )
							  :
							  <ListItem style={{marginTop: "-16px"}}>All done</ListItem>
						  }
					</List>*/}


				</div>
			</div>
		)
	}
}

export default connect(select, R.mergeAll([commentWizard, tableActions, commentActions]))(Comments)
// Section
// 	addFunc={props.COMMENT_ADD}
// 	count={count}
// 	titleName="Comments"
// 	expanded={commentQuery || props.sections.comments}
// 	card='comments'
// 	onToogle={props.SECTION_EXPAND}
// >



// WEBPACK FOOTER //
// ./src/routes/landlord/propertyForm/wizardComment/index.js